import GitHubCalendar from "react-github-calendar";
import { Box, Heading, Image, SimpleGrid } from "@chakra-ui/react";

function GitHubCal() {

  
  return (
    <Box>
      <Box pt="10px">
        <Heading color="#00ade7" size="lg">
          Github Activity
        </Heading>
      </Box>
      <Box  mt={["10px",null,"20px",null,"30px"]}>
      <GitHubCalendar
        username="madhukarkakade"
        years={[2022, 2023]}
        blockSize={20}
        blockMargin={2}
        theme={{ background: "transparent", text: "#333", grade4: "red" }}
        
      /></Box>
     

      <SimpleGrid columns={2} spacing={5} align="center" justify="center" mt={["10px",null,"20px",null,"30px"]}>
        <Image
          src="https://github-readme-stats.vercel.app/api?username=madhukarkakade&theme=dark&hide_border=false&include_all_commits=false&count_private=false&show_icons=true"
          data-aos="zoom-in"
        />
        <Image
          src="https://github-readme-streak-stats.herokuapp.com/?user=madhukar&theme=dark&hide_border=false"
          data-aos="zoom-in"
        />
      </SimpleGrid>
    </Box>
  );
}

export default GitHubCal;
